import * as XLSX from "xlsx";

const useReadSheet = async (fileUri, sheets = [], selectColumns = []) => {
  try {
    const response = await fetch(fileUri);
    const arrayBuffer = await response.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer);

    const colData = parseDataToCols(sheets, workbook);
    const rowData = parseDataToRows(sheets, workbook, false);

    // add select lists
    const selectLists = [];
    selectColumns.forEach((v) => {
      const colUp = returnColRowOrCell(v, colData)
        .filter((v, i, a) => a.indexOf(v) === i)
        .sort();

      selectLists.push(colUp);
    });

    return { rowData: rowData, colData: colData, selectLists: selectLists };
  } catch (err) {
    console.log(err || "Error loading file");
  }
};

const parseDataToCols = (sheets, workbook) => {
  // parse data
  const dataAr = {};
  sheets.forEach((v) => {
    const sheet = workbook.Sheets[v];
    const range = XLSX.utils.decode_range(sheet["!ref"]);
    const sheetLabel = v.replace(/[^a-z0-9]/gim, " ").replace(/\s+/g, "");
    dataAr[sheetLabel] = {};
    for (var colNum = range.s.c; colNum <= range.e.c; colNum++) {
      dataAr[sheetLabel][colNum] = [];
      for (var rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        rowNum > 0 &&
          (dataAr[sheetLabel][colNum][rowNum] =
            sheet[XLSX.utils.encode_cell({ r: rowNum, c: colNum })].v);
      }
    }
  });
  return dataAr;
};

const parseDataToRows = (sheets, workbook) => {
  // parse data
  const dataAr = {};
  sheets.forEach((v) => {
    const sheet = workbook.Sheets[v];
    const range = XLSX.utils.decode_range(sheet["!ref"]);
    const sheetLabel = v.replace(/[^a-z0-9]/gim, " ").replace(/\s+/g, "");
    dataAr[sheetLabel] = [];
    for (var rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
      dataAr[sheetLabel][rowNum] = [];
      for (var colNum = range.s.c; colNum <= range.e.c; colNum++) {
        rowNum > 0 &&
          (dataAr[sheetLabel][rowNum][colNum] =
            sheet[XLSX.utils.encode_cell({ r: rowNum, c: colNum })].v);
      }
    }
  });
  return dataAr;
};

export const returnColRowOrCell = (string, data) => {
  const keyAr = string.split(":");
  let returnOb = data;

  keyAr.forEach((v) => {
    returnOb = returnOb[v];
  });

  return Object.values(returnOb);
};



// const parseDataByRowOrCol = (sheets, workbook, byCol = true) => {
//   const levelAr = byCol ? ["c", "r"] : ["r", "c"];
//   const dataAr = {};
//   sheets.forEach((v) => {
//     const sheet = workbook.Sheets[v];
//     const range = XLSX.utils.decode_range(sheet["!ref"]);
//     const sheetLabel = v.replace(/[^a-z0-9]/gim, " ").replace(/\s+/g, "");
//     dataAr[sheetLabel] = {};
//     for (
//       var colNum = range.s[levelAr[0]];
//       colNum <= range.e[levelAr[0]];
//       colNum++
//     ) {
      
//       dataAr[sheetLabel][colNum] = {};
//       for (
//         var rowNum = range.s[levelAr[1]];
//         rowNum <= range.e[levelAr[1]];
//         rowNum++
//       ) {
//         rowNum > 0 &&
//           (dataAr[sheetLabel][colNum][rowNum] =
//             sheet[XLSX.utils.encode_cell({ r: rowNum, c: colNum })].v);
//       }
//     }
//   });
//   return dataAr;
// };

export const mergeWithPrevYear = (quartal, thema, data) => {
  const quartalPrev = (quartal.split("-")[0] - 1 ) + "-" + quartal.split("-")[1];
  const curRow = data.filter((v) => {
    if (v[0] == quartal && v[1] == thema) {
     return v;
    }
  });

   const prevRow = data.filter((v) => {
    if (v[0] == quartalPrev && v[1] == thema) {
     return v;
    }
  });

  return curRow[0].concat(prevRow[0]);
}

export const orderHonorarAufteilung = (inAr) => {
  const orderAr = [ "EGV", "MGV budgetiert", "MGV unbudgetiert", "SKT", "TSVG", "Zuschläge"];
  if(typeof inAr == "object"){
    inAr = Object.values(inAr);
  }
  const outAr = [];
  orderAr.forEach((v) => {
    inAr.forEach((w) => {
      if(w[2] == v){
        outAr.push(w);
      }
    })
  })
  return outAr;
}

export default useReadSheet;
